// import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const { FETCH_BALANCE_REQUEST, FETCH_BALANCE_SUCCESS, FETCH_BALANCE_FAILURE } = actions;

const fetchBalance = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_BALANCE_REQUEST });

    try {
      const response = await DataService.get('/balance');
      const balance = parseFloat(response.data.balance);
      dispatch({ type: FETCH_BALANCE_SUCCESS, payload: balance });
    } catch (error) {
      dispatch({ type: FETCH_BALANCE_FAILURE, payload: error.message });
    }
  };
};

export { fetchBalance };
